import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ css }) => {
  return {
    card: css`
      > .ant-card-body {
        max-width: 1200px;
      }
    `,
    amountField: css`
      margin-bottom: 12px;
    `
  }
})

export const useEditorStyles = createStyles(({ token }) => ({
  editor: {
    backgroundColor: token.colorWhite,
    '.ql-toolbar': { borderRadius: '8px 8px 0 0 ' },
    '.ql-toolbar.ql-snow': {
      borderBottom: 'none !important'
    },
    '.ql-container': {
      height: 250,
      borderTop: `1px solid ${token.colorBorder} !important`,
      borderRadius: '0 0 8px 8px'
    }
  }
}))
